<template>
  <div class="calendar-event-list">
    <template v-for="index in 6" :key="`p-calendar-event-list-item-${index}`">
      <div class="calendar-event-list__item">
        <div class="p-calendar-event-list-item" />
      </div>
    </template>
  </div>
</template>
